const vacation = {
  'vacation.title': 'Urlaubsverwaltung',
  'vacation.request': 'Urlaub beantragen',
  'vacation.entitlement': 'Urlaubskontingent {year}',
  'vacation.total': 'Gesamt',
  'vacation.used': 'Verbraucht',
  'vacation.planned': 'Geplant',
  'vacation.available': 'Verfügbar',
  'vacation.used.title': 'Verbraucht: {days}',
  'vacation.planned.title': 'Geplant: {days}',
  'vacation.form.title': 'Neuer Urlaubsantrag',
  'vacation.form.from': 'Von',
  'vacation.form.to': 'Bis',
  'vacation.form.notes': 'Kommentar (optional)',
  'vacation.form.submit': 'Einreichen',
  'vacation.form.cancel': 'Abbrechen',
  'vacation.status.PENDING': 'Ausstehend',
  'vacation.status.APPROVED': 'Genehmigt',
  'vacation.status.REJECTED': 'Abgelehnt',
  'vacation.my.title': 'Meine Urlaubsanträge',
  'vacation.col.from': 'Von',
  'vacation.col.to': 'Bis',
  'vacation.col.days': 'Tage',
  'vacation.col.status': 'Status',
  'vacation.col.substitute': 'Vertretung',
  'vacation.col.notes': 'Kommentar',
  'vacation.col.reason': 'Begründung',
  'vacation.col.submitted': 'Eingereicht',
  'vacation.col.employee': 'Mitarbeiter',
  'vacation.col.actions': 'Aktionen',
  'vacation.empty': 'Keine Anträge vorhanden',
  'vacation.team.title': 'Urlaubsanträge meines Teams',
  'vacation.team.open': '{count} offen',
  'vacation.user.fallback': 'User #{id}',
  'vacation.approve': 'Genehmigen',
  'vacation.reject': 'Ablehnen',
  'vacation.prompt.approve': 'Begründung (optional):',
  'vacation.prompt.reject': 'Begründung für die Ablehnung (Pflichtfeld):',
  'vacation.error.submit': 'Fehler beim Einreichen',
  'vacation.error.approve': 'Fehler bei der Genehmigung',
  'vacation.error.reject': 'Fehler bei der Ablehnung',
  'vacation.move': 'Verschieben',
  'vacation.move.title': 'Urlaub verschieben',
  'vacation.move.save': 'Verschieben',
  'vacation.move.hint': 'Neuer Zeitraum für den Antrag von {name}.',
  'vacation.move.error': 'Der Antrag konnte nicht verschoben werden',
  'vacation.delete': 'Löschen',
  'vacation.delete.confirm': 'Genehmigten Antrag von {name} ({from} – {to}) wirklich löschen? Gebuchte Tage werden zurückgebucht.',
  'vacation.delete.error': 'Der Antrag konnte nicht gelöscht werden',
  'vacation.substitute.reapprovalHint': 'Achtung: Dieser Antrag ist bereits genehmigt. Bei einem Vertreterwechsel muss er neu genehmigt werden und wird wieder „Ausstehend“.',
  'vacation.substitute.reapprovalConfirm': 'Der Antrag muss nach dem Vertreterwechsel neu genehmigt werden. Fortfahren?',
  'vacation.substitute.pick': 'Vertretung wählen…',
  'vacation.substitute.set': 'Vertretung festlegen',
  'vacation.substitute.unavailable': '{name} (nicht verfügbar: {reason})',
  'vacation.substitute.save': 'Speichern',
  'vacation.substitute.cancel': 'Abbrechen',
  'vacation.substitute.none': 'Keine Teamkollegen vorhanden',
  'vacation.form.substitute': 'Vertretung',
  'vacation.form.substituteRequired': 'Vertretung (Pflicht)',
  'vacation.form.substituteOptional': 'Vertretung (optional)',
  'vacation.form.substituteMandatoryHint': 'Dein Team verlangt für Urlaubsanträge eine Vertretung aus dem Team.',
  'vacation.form.substitutePickDates': 'Zeitraum wählen, um Vorschläge zu sehen',
  'vacation.substitute.error.load': 'Vorschläge konnten nicht geladen werden',
  'vacation.substitute.error.save': 'Vertretung konnte nicht gespeichert werden',
};

export default vacation;
